module.exports = __webpack_public_path__ + "static/media/lightBulb.06a3c708.jpg";